const fontSize = {
  xxs: '8px',
  xs: '10px',
  sm: '13px',
  md: '16px',
  lg: '20px',
  xl: '22px',
  xxl: '25px',
}

export default fontSize
